import resize from "../utils/resize";

const initMoreButton = () => {
  const buttons = document.querySelectorAll("[data-reviews-show-button]");
  if (!buttons.length) return;

  const wrapper = document.querySelector(".wrapper");

  const watchShowButton = () => {
    buttons.forEach((button) => {
      const card = button.parentElement;
      const cardTextMaxHeight = parseInt(window.getComputedStyle(card.querySelector(".coaching-reviews__slide-text")).maxHeight);
      const cardTextHeight = card.querySelector(".coaching-reviews__slide-text").scrollHeight;
      if (cardTextHeight <= cardTextMaxHeight) {
        button.classList.add("is-hidden");
      } else {
        button.classList.remove("is-hidden");
      }
    })
  }

  watchShowButton();
  resize(watchShowButton);

  wrapper.addEventListener("click", (evt) => {
    const openCard = document.querySelector('.coaching-reviews__slide.is-open');
    if (openCard) {
      setTimeout(() => {
        openCard.classList.remove('is-open');
        openCard.querySelector("[data-reviews-show-button]").textContent = "Читать далее";
      }, 50)
      
    }
    if (evt.target.closest("[data-reviews-show-button]")) {
      const button = evt.target.closest("[data-reviews-show-button]");
      const currentCard = evt.target.closest(".coaching-reviews__slide");
      currentCard.classList.add("is-open");
      button.textContent = "Свернуть";
    }
  });
};

export default initMoreButton;
